import React from "react";

import NextImage from "./NextImage";

const RaceInfoHeader = ({ courseName, country, numberOfRaces }) => {
  return (
    <div className="leg_head">
      <h2>
        <a href={`/`} type={"league"}>
          <i className="icon_flag">
            <NextImage
              src={`/assets/images/flags/${country?.toLowerCase().replace(/\s/g, "-") || "default"}.png`}
              alt={`${country} flag`}
              width={22}
              height={22}
              priority={false}
            />
          </i>
        </a>
        <div className="des">
          <span className="name">{courseName}</span>
          <span className="sb_inf">({numberOfRaces} Races)</span>
        </div>

      </h2>
    </div>
  );
};

export default RaceInfoHeader;
